import qs from 'query-string';
import rest from 'Services/restFootData';

function toParams(search) {
  if (!search) return {};
  return typeof search === 'string' ? qs.parse(search) : search;
}

// Match videos are not translated: no locale parameter, whatever the current project.
export function fetchMatchVideos(search) {
  const params = {
    'order[match.date]': 'desc',
    'order[ordering]': 'asc',
    groups: ['read_link', '_match'],
    itemsPerPage: 20,
    partial: 0,
    ...toParams(search),
  };

  return function(dispatch) {
    dispatch({ type: 'FETCH_MATCH_VIDEOS' });

    return rest
      .get('match_videos', { params })
      .then(
        res => dispatch({ type: 'FETCH_MATCH_VIDEOS_FULFILLED', payload: res.data }),
        err => dispatch({ type: 'FETCH_MATCH_VIDEOS_REJECTED', payload: err.response })
      );
  };
}

export function fetchMatchVideo(id) {
  return function(dispatch) {
    dispatch({ type: 'FETCH_MATCH_VIDEO' });

    return rest
      .get(`match_videos/${id}`, { params: { groups: ['read', '_match'] } })
      .then(
        res => dispatch({ type: 'FETCH_MATCH_VIDEO_FULFILLED', payload: res.data }),
        err => dispatch({ type: 'FETCH_MATCH_VIDEO_REJECTED', payload: err.response })
      );
  };
}

// The API resolves title, description, thumbnails, duration… from the YouTube URL,
// stamps the video as Adversport-owned and keeps match.hasVideo in sync.
export function addMatchVideo(matchVideo) {
  return function(dispatch) {
    dispatch({ type: 'ADD_MATCH_VIDEO' });

    return rest.post('match_videos', matchVideo).then(
      res => {
        dispatch({
          type: 'ADD_NOTIFICATION',
          payload: { messageKey: 'message_matchVideoAdded', type: 'success' },
        });
        return dispatch({ type: 'ADD_MATCH_VIDEO_FULFILLED', payload: res.data });
      },
      err => dispatch({ type: 'ADD_MATCH_VIDEO_REJECTED', payload: err.response })
    );
  };
}

export function updateMatchVideo(id, matchVideo) {
  return function(dispatch) {
    dispatch({ type: 'UPDATE_MATCH_VIDEO' });

    return rest.put(`match_videos/${id}`, matchVideo).then(
      res => {
        dispatch({
          type: 'ADD_NOTIFICATION',
          payload: { messageKey: 'message_matchVideoUpdated', type: 'success' },
        });
        dispatch({ type: 'UPDATE_MATCH_VIDEO_FULFILLED', payload: res.data });
        // Re-read with the read groups: the write response does not embed the match.
        return dispatch(fetchMatchVideo(id));
      },
      err => dispatch({ type: 'UPDATE_MATCH_VIDEO_REJECTED', payload: err.response })
    );
  };
}

export function deleteMatchVideo(id) {
  return function(dispatch) {
    dispatch({ type: 'DELETE_MATCH_VIDEO' });

    return rest.delete(`match_videos/${id}`).then(
      () => {
        dispatch({
          type: 'ADD_NOTIFICATION',
          payload: { messageKey: 'message_matchVideoDeleted', type: 'success' },
        });
        return dispatch({ type: 'DELETE_MATCH_VIDEO_FULFILLED', payload: { id } });
      },
      err => dispatch({ type: 'DELETE_MATCH_VIDEO_REJECTED', payload: err.response })
    );
  };
}
